import { adminOidcConfigurationsByCustomerByIdDeleteSlice } from './delete';
import { adminOidcConfigurationsByCustomerByIdPostSlice } from './post';
import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';

export const adminOidcConfigurationsByCustomerByIdReducers = combineReducers({
	delete: adminOidcConfigurationsByCustomerByIdDeleteSlice.asyncReducers,
	post: adminOidcConfigurationsByCustomerByIdPostSlice.asyncReducers
});

export const adminOidcConfigurationsByCustomerByIdWatchers = combineAllWatchers([
	adminOidcConfigurationsByCustomerByIdDeleteSlice.asyncWatchers,
	adminOidcConfigurationsByCustomerByIdPostSlice.asyncWatchers
]);
